// 比較散布図（§10.3）。x=推奨軍資金(ハーフ)、y=期待時給。左上ほど良い（低軍資金・高時給）。
import { Chart, LinearScale, PointElement, ScatterController, Tooltip } from 'chart.js';

Chart.register(ScatterController, PointElement, LinearScale, Tooltip);

const COL = { gold: '#e0a53b', cyan: '#74b8c6', line: '#2b3043', faint: '#6f6d66' };

export interface ScatterPoint {
  name: string;
  bankHalf: number;
  expectedHourly: number;
  reachable: boolean;
}

export class ScatterChart {
  private chart: Chart<'scatter'> | null = null;
  constructor(private readonly canvas: HTMLCanvasElement) {}

  update(points: ScatterPoint[], unit: string): void {
    const data = points.map((p) => ({ x: p.bankHalf, y: p.expectedHourly, name: p.name }));
    const colors = points.map((p) => (p.reachable ? COL.gold : COL.cyan));
    if (!this.chart) {
      this.chart = new Chart(this.canvas, {
        type: 'scatter',
        data: {
          datasets: [
            { data, pointBackgroundColor: colors, pointBorderColor: colors, pointRadius: 6, pointHoverRadius: 8 },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              title: { display: true, text: `推奨軍資金 ハーフ (${unit})`, color: COL.faint, font: { size: 10 } },
              ticks: { color: COL.faint, font: { family: 'JetBrains Mono', size: 10 } },
              grid: { color: COL.line },
              border: { color: COL.line },
            },
            y: {
              title: { display: true, text: `期待時給 (${unit})`, color: COL.faint, font: { size: 10 } },
              ticks: { color: COL.faint, font: { family: 'JetBrains Mono', size: 10 } },
              grid: { color: COL.line },
              border: { color: COL.line },
            },
          },
          plugins: {
            tooltip: {
              callbacks: {
                label: (item) => {
                  const p = item.raw as { x: number; y: number; name: string };
                  return `${p.name}: 軍資金 ${Math.round(p.x).toLocaleString()} / 時給 ${Math.round(p.y).toLocaleString()} ${unit}`;
                },
              },
            },
          },
        },
      });
    } else {
      const ds = this.chart.data.datasets[0]!;
      ds.data = data;
      ds.pointBackgroundColor = colors;
      ds.pointBorderColor = colors;
      const sx = this.chart.options.scales?.x;
      if (sx && 'title' in sx && sx.title) sx.title.text = `推奨軍資金 ハーフ (${unit})`;
      const sy = this.chart.options.scales?.y;
      if (sy && 'title' in sy && sy.title) sy.title.text = `期待時給 (${unit})`;
      this.chart.update('none');
    }
  }

  destroy(): void {
    this.chart?.destroy();
    this.chart = null;
  }
}
